import {
	collection, doc,
	onSnapshot, orderBy, query
} from "firebase/firestore";

import { signInToBroadcastService } from "_services/firebase";

import { firestoreConfig } from "..";

const db  = firestoreConfig.broadcast;
const col = "broadcast-sessions";

const convertToString = broadcastId => {
	return String ( broadcastId );
};

export const getTopDonor = async ( broadcastId, callback ) => {
	await signInToBroadcastService ();

	const ref     = doc ( db, col, convertToString ( broadcastId ) );
	const chatRef = collection ( ref, "pinnedChat" );
	const _query  = query ( chatRef );

	return onSnapshot ( _query, snapshot => {
		callback ( snapshot );
	} );
};

export const getMutedUsersList = async ( broadcastId, callback ) => {
	await signInToBroadcastService ();

	const ref           = doc ( db, col, convertToString ( broadcastId ) );
	const mutedUsersRef = collection ( ref, "bannedUsers" );
	const _query        = query ( mutedUsersRef );

	return onSnapshot ( _query, snapshot => {
		callback ( snapshot );
	} );
};

export const getBlockedUsersList = async ( broadcastId, callback ) => {
	await signInToBroadcastService ();

	const ref             = doc ( db, col, convertToString ( broadcastId ) );
	const blockedUsersRef = collection ( ref, "blockedUsers" );
	const _query          = query ( blockedUsersRef );

	return onSnapshot ( _query, snapshot => {
		callback ( snapshot );
	} );
};

export const getDonationsList = async ( broadcastId, callback ) => {
	await signInToBroadcastService ();

	const ref          = doc ( db, col, convertToString ( broadcastId ) );
	const donationsRef = collection ( ref, "donations" );
	const _query       = query ( donationsRef, orderBy ( "createdAt" ) );

	return onSnapshot ( _query, snapshot => {
		callback ( snapshot );
	}, error => {
		callback ( null, error );
	} );
};
